import { Fragment, ReactElement, useCallback, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import ResearchNotificationsShared from 'shell/components/shared/research-notifications/list';
import { getBaseUrl } from '../get-base-url';
import { BreadcrumbItem } from '../../breadcrumb';
import { IconButton } from '@mui/material';
import { Print } from '@mui/icons-material';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { __ACT_API_URL__ } from 'shell/constants/environment';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { ModalViewerPDF } from '../../pdf-modal';
import { blobToBase64 } from 'shell/utils/base64-to-blob';
import { IdAmbito } from 'shell/constants/id-ambito';

interface AnscNotificationsSharedProps {
  scope?: string;
  items?: BreadcrumbItem[];
  title?: string;
}

const AnscNotificationsShared = ({
  scope,
  items,
  title = 'Aggiornamento anagrafe da ANSC',
}: AnscNotificationsSharedProps): ReactElement => {
  const params = useParams();
  const idCatParams = params.idCat || undefined;
  const [pdfModal, setPdfModal] = useState({ data: '', name: '', open: false });

  const baseUrl: string = useMemo(() => {
    return getBaseUrl(scope, idCatParams);
  }, [scope, idCatParams]);

  const getPdf = useHttpClient<Blob>(`${__ACT_API_URL__}/notifiche-ansc/stampa`, {
    options: { method: 'POST' },
  });

  const onPrint = useCallback(
    (item) => {
      (
        getPdf({
          data: item.el,
          responseType: 'blob',
        }) as ResponsePromise<Blob>
      ).then((response) => {
        if (response?.data) {
          const blob = new Blob([response.data], { type: 'application/pdf' });
          blobToBase64(blob).then((base64) => {
            setPdfModal({
              data: base64.split(',')[1],
              name: 'Certificazione Stato Civile',
              open: true,
            });
          });
        }
      });
    },
    [getPdf]
  );

  return (
    <Fragment>
      <ResearchNotificationsShared
        scope={scope}
        items={items}
        baseUrl={baseUrl}
        title={title}
        checkVisibilityActions={{ read: false, edit: true, delete: false }}
        addedActions={(item) =>
          item.scope && item.scope === IdAmbito.Stampa ? (
            <IconButton onClick={() => onPrint(item)}>
              <Print />
            </IconButton>
          ) : (
            <></>
          )
        }
        endpointParams={{
          idEvent: '0',
        }}
      />
      {pdfModal.open ? (
        <ModalViewerPDF
          open={pdfModal.open}
          onClose={() => setPdfModal({ ...pdfModal, open: false })}
          data={pdfModal.data}
          name={pdfModal.name}
        />
      ) : undefined}
    </Fragment>
  );
};

AnscNotificationsShared.displayName = 'Ansc Notifications Shared component';

export default AnscNotificationsShared;
